// extracted by mini-css-extract-plugin
module.exports = {"resultbox":"Result_resultbox__2F9XR","tablediv":"Result_tablediv__3ezz3","profile":"Result_profile__oowLk","buttons":"Result_buttons__1OWv4"};